import React, { useContext } from "react";
import { FormContext } from "../../app/App";
import './Button.css';

export default function Button({ props })
{
    const { button = 'button', disabled = false, ...restProps } = props;
    const { show, setShow } = useContext(FormContext);
    const { type, setType } = useContext(FormContext);
    
    return (
        <>
            <button onClick={ button === 'button' ? () => { setShow(!show); setType(restProps.dataName) } : () => { } } disabled={ disabled } type={ button } className={ restProps.type }>{ restProps.name }</button>
        </>
    )
}